module.exports = __webpack_public_path__ + "static/media/v33.e7ab06c5.mp4";